import PropTypes from 'prop-types';
import React from 'react';

import Item from './Item';

const List = ({ events }) => <ul className="event-list">
	{events.map(event =>
		<Item event={event} key={event.id} />
	)}
</ul>;

List.propTypes = {
	events: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
	})),
};

export default List;
